module.exports = __webpack_public_path__ + "media/images/gc-logo-083ffaebcd96e66a80f46a9946622bde.png";